import { memo, useState } from 'react';
import { useDebounce } from 'use-debounce';

import { type BaseStringSelectProps, StringSelect } from '~/components/StringSelect';
import { usePrivateCameraModelsList } from '~/swr-hooks/filters/usePrivateCameraModelsList';

type PrivateCameraModelsSelectProps = {
  boardId: string | undefined;
  make: string | undefined;
  libraryId: string | undefined;
} & BaseStringSelectProps;

export const PrivateCameraModelsSelect = memo(
  ({ boardId, make, libraryId, ...props }: PrivateCameraModelsSelectProps) => {
    const [searchValue, setSearchValue] = useState('');

    const [debouncedSearchValue] = useDebounce(searchValue, 200, {
      trailing: true,
    });

    const { data = [], isLoading } = usePrivateCameraModelsList({
      search: debouncedSearchValue,
      boardId,
      make,
      libraryId,
    });

    return (
      <StringSelect
        id="camera-model"
        placeholder="Search for model"
        isLoading={isLoading}
        values={data}
        onInputChange={setSearchValue}
        {...props}
      />
    );
  },
);

PrivateCameraModelsSelect.displayName = 'PrivateCameraModelsSelect';
